import styled from "styled-components";


export const HeaderWrapper = styled.header`
  height: 45px;
  padding-top: 1rem;
  
`;

export const HeaderContainer = styled.div.attrs({
  className: "container",
})`
 // text-align: left;
 // height: 100%;
//  position: relative;


`;

export const Hdr = styled.h2`
   position: absolute;
   left:25px;
   font-size: 1.4rem;
   line-height: 1.5rem;
   display: flex;
   align-items: center; 
 
    height: 50px;
  
   text-align :left ;
  
   
   width:70%;
   
   @media screen and (max-width: 280px) {
      font-size: 1.2rem;
    }
   
 


`;

export const FirstText = styled.h2``;

export const SecondText = styled.h1`

`;

export const ThirdText = styled.h5.attrs({
  className: "text-light",
})``;

export const ContainerMyProfile = styled.div`
  background: linear-gradient(var(--color-primary), transparent);
  width: 2rem;
  height: 2rem;
  position: absolute;
  left: calc(50% - 11rem);
  margin-top: 0.1rem;
  border-radius: 12rem 12rem 0 0;
  padding: 5rem 1.5rem 1.5rem 1.5rem;
  overflow: hidden;
`;

export const MyPhoto = styled.img`

`;

export const SelLang = styled.select`
  position: absolute;
   
  left:86%;
  top:19px;
  height:40px;
  width: 40px;
  background: grey;
  color: white;
  padding: 1px;
  border-radius: 50px;
  font-weight: bold;
  
 
`;
export const Search = styled.div`
    position: absolute;
   
    left:82%;
    transform:  translate(-90%,10%);
    background: #2f3640;
    height: 40px;
   
    border-radius: 50px;
    padding: 10px;

&:hover > .searchInput {
    width: 180px;
    padding: 0 6px;
    
}

&:hover > .searchButton {
  background: white;
  color : #2f3640;
  left: 78%;
  top:15%;
 
}

& > .searchButton {
    color: white;
   
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #2f3640;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.4s;
    position: absolute;
   
    left: 12%;
    top:15%;
}

& > .searchInput {
    border:none;
    background: none;
    outline:none;
    float:left;
    padding: 10px;
    color: white;
    font-size: 16px;
    transition: 0.4s;
    line-height: 20px;
    width: 0px;

}

@media screen and (max-width: 620px) {
&:hover > .searchInput {
    width: 130px;
    padding: 0 0;
}
}
@media screen and (max-width: 280px) {
&:hover > .searchInput {
    width: 100px;
    padding: 0 9px;
}
&:hover > .searchButton {
 
  left: 74%;
  top:13%;
 
}
}



`;

export const ScrollDownLink = styled.a`
  position: absolute;
  right: -2.3rem;
  bottom: 5rem;
  transform: rotate(90deg);
  font-weight: 300;
  font-size: 0.9rem;

  @media screen and (max-width: 600px) {
    display: none;
  }
`;
